/** Entrega un `Blob` al usuario como archivo descargado (enlace de objeto temporal). */
export function guardarArchivo(blob: Blob, nombreArchivo: string): void {
  const url = URL.createObjectURL(blob);
  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = nombreArchivo;
  enlace.rel = 'noopener';
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  // Se revoca después: algunos navegadores inician la descarga de forma asíncrona.
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
